import axios, { AxiosResponse } from "axios";
import {
    CreateAccumulatorRequest,
    CreateAccumulatorResponse
} from "../../../../interfaces/Accumulator/types";
import { getCsrftoken } from "../../../../helpers/csfrToken";

export const createAccumulator = async (
    data: CreateAccumulatorRequest
): Promise<AxiosResponse<CreateAccumulatorResponse>> => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    const response = await axios.post<CreateAccumulatorResponse>(
        `${process.env.REACT_APP_DJANGO_SERVER_URL}/api/staff/v1/acb/mock-create`, 
        data, headers
    )
    return response
}